export const fieldTypes = {
  POLAR_QUESTION: "POLAR_QUESTION",
  DROPDOWN: "DROPDOWN",
  DATEPICKER: "DATEPICKER",
  INPUT: "INPUT",
  LABEL: "LABEL"
};

export const formFieldQueryStatus = {
  OPEN: "OPEN",
  CLOSE: "CLOSE",
  REOPENED: "REOPENED"
};

export const historyStatus = {
  MODIFIED: "MODIFIED"
};

export const historyStatusText = {
  MODIFIED: "Original Submission"
};

// approve
export const approvalStatus = {
  APPROVED: "APPROVED",
  NOT_APPROVED: "NOT_APPROVED"
};
export const approvalStatusText = {
  APPROVED: "Approved",
  NOT_APPROVED: "Unapproved"
};

// verification
export const verificationStatus = {
  VERIFIED: "VERIFIED",
  NOT_VERIFIED: "NOT_VERIFIED"
};
export const verificationStatusText = {
  VERIFIED: "Verified",
  NOT_VERIFIED: "Unverified"
};

// signoff
export const signoffStatus = {
  SIGNEDOFF: "SIGNEDOFF",
  PENDING: "PENDING"
};
export const signoffStatusText = {
  SIGNEDOFF: "Signed Off",
  PENDING: "Unsigned Off"
};

// Review
export const reviewStatus = {
  REVIEWED: "REVIEWED",
  UNREVIEWED: "UNREVIEWED"
};

export const reviewStatusText = {
  REVIEWED: "Reviewed",
  UNREVIEWED: "Unreviewed"
};

// Locked
export const lockStatus = {
  LOCKED: "LOCKED",
  UNLOCKED: "UNLOCKED"
};

export const lockStatusText = {
  LOCKED: "Locked",
  UNLOCKED: "Unlocked"
};

// NODE API FORM STATUSES
export const approveStatusNapi = {
  APPROVED: "approved",
  NOT_APPROVED: "unapproved"
};

export const verifiedStatusNapi = {
  VERIFIED: "verified",
  NOT_VERIFIED: "unverified"
};

export const signoffStatusNapi = {
  SIGNEDOFF: "SIGNEDOFF",
  PENDING: "PENDING"
};

export const reviewStatusNapi = {
  REVIEWED: "REVIEWED",
  UNREVIEWED: "UNREVIEWED"
};

export const lockedStatusNapi = {
  LOCKED: "LOCKED",
  UNLOCKED: "UNLOCKED"
};
